import { bajaPut } from "#api/Api/baja"
import { Alert, Box, Typography } from "@mui/material"
import { useCallback } from "react"
import { UseDialogBajaContext } from "./DialogBajaContext"
import { DialogMaster } from "#core/components/dialog/Dialog"

export default function TerminationSendEmail({ open, setOpen }) {
	const { baja, reload } = UseDialogBajaContext()

	const handleSubmit = useCallback(() => {
		const data = {
			id: baja.id,
			email_send: true,
		}

		const success = () => {
			reload()
			setOpen(false)
		}
		bajaPut(baja.id, data, { success })
	}, [baja.id, reload, setOpen])

	return (
		<DialogMaster
			{...{
				open,
				setOpen,
				handleSubmit,
				title: "Enviar Entrevista de salida",
				maxWidth: "sm",
			}}
		>
			<Box sx={{ display: "grid", gap: 2 }}>
				<Typography variant="body1" sx={{ fontWeight: 500 }} textAlign={"center"}>
					Se enviará el correo al correo personal registrado del colaborador.
				</Typography>
			</Box>
		</DialogMaster>
	)
}
